import * as React from 'react';
import { cn } from '@/lib/utils';

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        ref={ref}
        className={cn(
          'flex min-h-[88px] w-full rounded-md border border-bone-deep bg-surface px-3.5 py-2.5 text-sm text-ink placeholder:text-ink-muted',
          'transition-[border-color,box-shadow] duration-200 ease-out',
          'focus:border-accent-glow focus:outline-none focus:ring-2 focus:ring-accent-glow',
          'disabled:cursor-not-allowed disabled:opacity-50',
          'resize-none',
          className,
        )}
        {...props}
      />
    );
  },
);
Textarea.displayName = 'Textarea';

export { Textarea };
